module.exports = __webpack_public_path__ + "static/media/StarRating.0682a634.png";